var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input"},[_c('select',{attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.modelValue},on:{"input":function($event){return _vm.$emit('update:modelValue', $event)}}},_vm._l((_vm.options),function(options,index){return _c('option',{key:index,domProps:{"value":options.value}},[_vm._v(_vm._s(options.text))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }